import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'
import { IAnalyticsPeriod } from 'xangle-charts'

import { explorerApi } from '~/api/client'
import {
  analyticsTokenNesoHoldersKey,
  analyticsTokenNftHoldersKey,
  analyticsTokenNxpcHoldersKey
} from '~/api/service/query-keys.const'
import { IAnalyticsParam, IAnalyticsPeriod } from '~/types/analytics.type'
import { LineChartModel } from '~/types/model/analytics.model'

export const analyticsTokenService = {
  useGetNesoHolders: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getNesoHolders = async () => {
      const res = await explorerApi.analyticsController.getNesoHolder({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }

    return useQuery([ ...analyticsTokenNesoHoldersKey, params ], getNesoHolders, {
      enabled: isEnable,
    })
  },
  useGetNxpcHolders: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getNxpcHolders = async () => {
      const res = await explorerApi.analyticsController.getNxpcHolder({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }

    return useQuery([ ...analyticsTokenNxpcHoldersKey, params ], getNxpcHolders, {
      enabled: isEnable,
    })
  },
  useGetNftHolders: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getNftHolders = async () => {
      const res = await explorerApi.analyticsController.getNftHolder({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsTokenNftHoldersKey, params ], getNftHolders, {
      enabled: isEnable,
    })
  }
}